<div class="vh_center mt-4">
  <div col="12">
    <div style=" margin:0px; " class="vh_center">
      <img class=" " src="assets/img/c_va.png" width="27" height="27" style=" float:left;" />
      <div style="width:130px; height:5px; background-color: #fcb816;"></div>
      <img class=" " src="assets/img/c_yl.png" width="27" height="27" style=" float:left;" />
      <div style="width:130px; height:5px; background-color: #dadada;"></div>
      <img class=" " src="assets/img/c_ge.png" width="27" height="27" style=" float:left;" />
      <div style="width:130px; height:5px; background-color: #dadada;"></div>
      <img class=" " src="assets/img/c_ge.png" width="27" height="27" style=" float:left;" />
      <div style="width:130px; height:5px; background-color: #dadada;"></div>
      <img class=" " src="assets/img/c_ge.png" width="27" height="27" style=" float:left;" />
    </div>
  </div>
</div>
<div class="vh_center mt-2">
  <div col="12">
    <div style=" margin:0px; font-size: 14px; color:#999999; " class="vh_center">
      <div style="width:210px; padding-left: 45px;  background-color: #ffffff;">File Validation</div>
      <div style="width:150px;  padding-left: 15px; background-color: #ffffff;">Quote</div>
      <div style="width:150px; padding-left: 0px;  background-color: #ffffff;">Order Details</div>
      <div style="width:150px; padding-left: 0px;  background-color: #ffffff;">Review & Confirm</div>
      <div style="width:150px;   padding-left: 15px;  background-color: #ffffff;">Place Order</div>
    </div>
  </div>
</div>
<section class="ofp-sect" style="overflow-x: hidden;" >
  <h2 class="text-center header-title page_top_space"> <b>Board Details</b> </h2>
  <div>

  </div>
  <div class="row g-3 justify-content-center">
    <div class="col-12 text-center">
      <!-- <div class="row">
      <div><a class="ofp-link" target="_blank" href="{{apiService.FAQ_URL}}">FAQ</a><span style="color: #0787bc !important;">|</span><a class="ofp-link" target="_blank"  href="{{apiService.Pcb_Specification_URL}}">Specification for Online Quote</a></div>
    </div> -->
    <div class="row">
      <div><b>NOTE</b>: Hover over each field to get values applicable for online quote. If your design is outside these specs, you will be navigated to the <b>Custom Quote</b> flow</div>
    </div>
    <!-- <div class="row mt-3 mb-3" id="error-msg-sec" *ngIf="commonService.commonMainObj.uploadedFilesData.fileWarnings">
    <div class="red-txt">Issues found in uploaded files are not yet fixed, hence we can only generate a budgetary quote. To get a final quote, please upload new files</div>
  </div> -->
</div>
</div>
<div class="text-center txt-align mt-3">
  <div class="text-center bdr-sec">
    <div class="p-1"> <img class=" " src="assets/img/Extracted_icon.png" width="25" height="25" /> Extracted From Uploaded Data File</div>
    <div class="p-1"> <img class=" " src="assets/img/Default_icon.png" width="25" height="25" /> Default Value</div>
    <div class="p-1"> <img class=" " src="assets/img/Updated_icon.png" width="25" height="25" /> User Updated Value</div>
  </div>
</div>
<div class="board-details-container" role="main">
  <form class="needs-validation" novalidate [formGroup]="personalForm" autocomplete="off">
    <div class="card-container">
      <div class="container-title">Personal Information</div>
      <div class="row mb-3 mtop-3"  style="display: contents;">
        <div class="col-12 pl-2">
          <div class="row">
            <div class="mb-3 col-12 col-lg-61 col-md-121 col-sm-121">
              <div class="row mb-3 mtop-3">
                <div class="col-3 brd-label">
                  <div class="ofp-tooltip">
                    <label for="email">Email:<span style="color:red;padding-left: 3px;">*</span></label>
                  </div>
                </div>
                <div class="col-6">
                  <input type="email" name="email" class="form-control" id="email" #userEmail placeholder="john.doe@gmail.com" formControlName="email" [(ngModel)]="boardDetailList.email" required  (keyup)="commonService.removeRedBorder('email'); validateDomain();" [readonly]="commonService.commonMainObj.userData.firstName"/>
                  @if (!isValid) {
                    <div class="validation-errors">
                      @for (validation of login_validation_messages.email; track validation) {
                        @if (personalForm.get('email')?.hasError(validation.type) && (personalForm.get('email')?.dirty || personalForm.get('email')?.touched)) {
                          <div class="error-message">
                            {{ validation.message }}
                          </div>
                        }
                      }
                    </div>
                  }
                  @if (isValid && domain) {
                    <p class="error-message">{{commonService.commonMainObj.invalidEmailErrorMsg}}</p>
                  }
                  <!-- <p *ngIf="isValid">Valid domain!</p> -->
                </div>
              </div>
            </div>
            <div class="col-6 col-lg-61 col-md-121 col-sm-121"></div>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>

<div class="board-details-container">
  <form class="needs-validation" novalidate [formGroup]="boardDetailsForm" autocomplete="off">
    <div class="card-container">

      <div class="container-title">Basic Board Info</div>
      <div class="row mb-3 mt-3" style="display: contents;">
        <div class="col-12 pl-2">
          <div class="row">
            <div class="mb-3 col-6 col-lg-61 col-md-121 col-sm-121">
              <div class="row mb-3 mtop-3">
                <div class="col-6 brd-label">
                  <div class="ofp-tooltip">
                    <label for="partNumber" (mouseover)="showToolTip(1)" (mouseout)="hideToolTip(1)">Part Number:<span style="color:red;padding-left: 3px;">*</span></label>
                    <span class="tooltiptext" id="boardDetailLabel-1"></span>
                  </div>
                </div>
                <div class="col-6" style="display: flex; align-items: baseline;">
                  <input type="text" class="form-control" id="partNumber" autocomplete="off" placeholder="Part Number" formControlName="partNumber" [(ngModel)]="boardDetailList.partNumber" required name="partNumber" readonly />
                  <div  class="ofp-tooltip" id="numberOfHolesTotipHide">
                    <img class=" " src="assets/img/{{commonService.commonMainObj.partNumberImg}}.png" width="22" height="22" (mouseover)="showImageToolTip(commonService.commonMainObj.partNumberImg)" (mouseout)="hideImageToolTip(commonService.commonMainObj.partNumberImg)" style="margin-left: 10px;"/>
                    <span class="tooltiptext right-img-tooltip lableImageLabel-{{commonService.commonMainObj.partNumberImg}}"></span>
                  </div>
                </div>
              </div>
              <div class="row mb-3 mt-1point5">
                <div class="col-6 brd-label ">
                  <div class="ofp-tooltip">
                    <label for="revision" (mouseover)="showToolTip(31)" (mouseout)="hideToolTip(31)">Revision:</label>
                    <span class="tooltiptext" id="boardDetailLabel-31"></span>
                  </div>
                </div>
                <div class="col-6" style="display: flex; align-items: baseline;">
                  <input type="text" class="form-control" id="revision" autocomplete="off" placeholder="Revision" formControlName="revision" [(ngModel)]="boardDetailList.revision" required name="revision" readonly/>
                  <div  class="ofp-tooltip" id="partNumberHide">
                    <img class=" " src="assets/img/{{commonService.commonMainObj.partRevisionImg}}.png" width="22" height="22" (mouseover)="showImageToolTip(commonService.commonMainObj.partRevisionImg)" (mouseout)="hideImageToolTip(commonService.commonMainObj.partRevisionImg)" style="margin-left: 10px;"/>
                    <span class="tooltiptext right-img-tooltip lableImageLabel-{{commonService.commonMainObj.partRevisionImg}}"></span>
                  </div>
                </div>
              </div>
              <div id="mypcbImgResult" class="img-zoom-result" style="visibility: hidden;"></div>
              <div class="row mb-3 mt-1point5">
                <div class="col-6 brd-label ">
                  <div class="ofp-tooltip">
                    <label for="NumofLayers" (mouseover)="showToolTip(2)" (mouseout)="hideToolTip(2)">Number of Layers:<span style="color:red;padding-left: 3px;">*</span></label>
                    <span class="tooltiptext" id="boardDetailLabel-2"></span>
                  </div>
                </div>
                <div class="col-6" style="display: flex; align-items: baseline;">
                  <select #NumberofLayers  class="form-select" id="NumofLayers"  (change)="validationOnlayers(NumberofLayers.value)" formControlName="layers" [(ngModel)]="boardDetailList.layers" (change)="commonService.removeRedBorder('NumofLayers')">
                  </select>
                  <div  class="ofp-tooltip" id="numOfLayersIndicateDiv">
                    <img class=" " src="assets/img/{{layersImg}}.png" width="22" height="22" (mouseover)="showImageToolTip(layersImg)" (mouseout)="hideImageToolTip(layersImg)" style="margin-left: 10px;"/>
                    <span class="tooltiptext labelimagetooltip lableImageLabel-{{layersImg}}"></span>
                  </div>
                </div>
              </div>
              <div class="row mb-3 mt-1point5">
                <div class="col-6 brd-label">
                  <div class="ofp-tooltip">
                    <label for="dimensionX" (mouseover)="showToolTip(32)" (mouseout)="hideToolTip(32)">Individual Board Dimensions (inches):<span style="color:red;padding-left: 3px;">*</span></label>
                    <span class="tooltiptext" id="boardDetailLabel-32"></span>
                  </div>
                </div>
                <div class="col-6" style="display: flex;align-items: baseline;">
                  <div class="col-6 wd50 pr-13">
                    <input  type="text" class="form-control" #boardDimensionX id="dimensionX" autocomplete="off" placeholder="Length" formControlName="dimensionX" (change)="changeInSelectInput($event)" [(ngModel)]="boardDetailList.dimensionX" required name="dimensionX" (keyup)="commonService.removeRedBorder('dimensionX')" (input)="onDecimalInput($event)"/>
                    <div class="validation-errors">
                      @for (validation of board_details_validation_messages.dimensionX; track validation) {
                        @if (boardDetailsForm.get('dimensionX')?.hasError(validation.type) && (boardDetailsForm.get('dimensionX')?.dirty || boardDetailsForm.get('dimensionX')?.touched) ) {
                          <div class="error-message">
                            {{ validation.message }}
                          </div>
                        }
                      }
                    </div>
                  </div>
                  <span class="xmultiply">X</span>
                  <div class="col-6 wd50 pr-16">
                    <div style="display: flex;align-items: baseline;">
                      <input type="text" class="form-control" #boardDimensionY id="dimensionY" autocomplete="off" placeholder="Breadth" formControlName="dimensionY" (change)="changeInSelectInput($event)" [(ngModel)]="boardDetailList.dimensionY" required name="dimensionY" (keyup)="commonService.removeRedBorder('dimensionY')" (input)="onDecimalInput($event)"/>
                      <div  class="ofp-tooltip" id="IndividualDimensionLableHide">
                        <img class=" " src="assets/img/{{boardDimensionImg}}.png" width="22" height="22" (mouseover)="showImageToolTip(boardDimensionImg)" (mouseout)="hideImageToolTip(boardDimensionImg)" style="margin-left: 5px;"/>
                        <span class="tooltiptext labelimagetooltip lableImageLabel-{{boardDimensionImg}}"></span>
                      </div>
                    </div>
                    <div class="validation-errors">
                      @for (validation of board_details_validation_messages.dimensionY; track validation) {
                        @if (boardDetailsForm.get('dimensionY')?.hasError(validation.type) && (boardDetailsForm.get('dimensionY')?.dirty || boardDetailsForm.get('dimensionY')?.touched) ) {
                          <div class="error-message">
                            {{ validation.message }}
                          </div>
                        }
                      }
                    </div>
                  </div>

                </div>

              </div>
              <div class="row mb-3 mt-1point5">
                <div class="col-6 brd-label">
                  <div class="ofp-tooltip">
                    <label for="boardAsArrayDiv" (mouseover)="showToolTip(3)" (mouseout)="hideToolTip(3)">Boards setup as an array:</label>
                    <span class="tooltiptext" id="boardDetailLabel-3"></span>
                  </div>
                </div>
                <div class="col-6 btn-group1" id="boardAsArrayDiv" style="display: flex; align-items: baseline;">
                  <input (click)="switchOfButtons($event)" type="button" class="btn btn-switch " id="boardAsArrayYes" value="Yes"/>
                  <input (click)="switchOfButtons($event)" type="button" class="btn btn-switch " id="boardAsArrayNo" value="No" style="margin-right: 10px;"/>
                  <div  class="ofp-tooltip">
                    <img class=" " src="assets/img/{{boardAsArrayImg}}.png" width="22" height="22" (mouseover)="showImageToolTip(boardAsArrayImg)" (mouseout)="hideImageToolTip(boardAsArrayImg)"/>
                    <span class="tooltiptext labelimagetooltip lableImageLabel-{{boardAsArrayImg}}"></span>
                  </div>
                </div>
              </div>
              @if (boardAsArraySelected == true) {
                <div class="row mb-3 mt-1point5">
                  <div class="col-6 brd-label">
                    <div class="ofp-tooltip">
                      <label for="boardsPerArray" (mouseover)="showToolTip(38)" (mouseout)="hideToolTip(38)">Boards per array:<span style="color:red;padding-left: 3px;">*</span></label>
                      <span class="tooltiptext" id="boardDetailLabel-38"></span>
                    </div>
                  </div>
                  <div class="col-6">
                    <div style="display: flex; align-items: baseline;">
                      <input type="text" class="form-control" #boardPerArray id="boardsPerArray" autocomplete="off" placeholder="Boards per array" formControlName="boardsPerArray" (change)="changeInSelectInput($event)" [(ngModel)]="boardDetailList.boardsPerArray" required name="boardsPerArray" (keyup)="populateQuantityInputs(boardDetailList.boardsPerArray)" (keyup)="commonService.removeRedBorder('boardsPerArray')"/>
                      <div  class="ofp-tooltip" id="boardPerArrayHide" style="display: none;">
                        <img class=" " src="assets/img/{{boardsPerArrayImg}}.png" width="22" height="22" (mouseover)="showImageToolTip(boardsPerArrayImg)" (mouseout)="hideImageToolTip(boardsPerArrayImg)" style="margin-left: 10px;"/>
                        <span class="tooltiptext labelimagetooltip lableImageLabel-{{boardsPerArrayImg}}"></span>
                      </div>
                    </div>
                    <div class="validation-errors">
                      @for (validation of board_details_validation_messages.boardsPerArray; track validation) {
                        @if (boardDetailsForm.get('boardsPerArray')?.hasError(validation.type) && (boardDetailsForm.get('boardsPerArray')?.dirty || boardDetailsForm.get('boardsPerArray')?.touched) ) {
                          <div class="error-message">
                            {{ validation.message }}
                          </div>
                        }
                      }
                    </div>
                  </div>
                </div>
              }
              @if (boardAsArraySelected == true) {
                <div class="row mb-3 mt-1point5">
                  <div class="col-6 brd-label">
                    <div class="ofp-tooltip">
                      <label for="boardDimensionsDiv" (mouseover)="showToolTip(39)" (mouseout)="hideToolTip(39)">Array Dimensions (inches):<span style="color:red;padding-left: 3px;">*</span></label>
                      <span class="tooltiptext" id="boardDetailLabel-39"></span>
                    </div>
                  </div>
                  <div class="col-6" id="boardDimensionsDiv" style="display: flex;">
                    <div class="col-6 wd50 pr-13">
                      <input type="text" class="form-control" #arrayDimensionX id="arrayDimensionX" autocomplete="off" placeholder="Length" formControlName="arrayDimensionX" (change)="changeInSelectInput($event)" [(ngModel)]="boardDetailList.arrayDimensionX" required name="arrayDimensionX" (keyup)="commonService.removeRedBorder('arrayDimensionX')" (input)="onDecimalInput($event)"/>
                      <div class="validation-errors">
                        @for (validation of board_details_validation_messages.arrayDimensionX; track validation) {
                          @if (boardDetailsForm.get('arrayDimensionX')?.hasError(validation.type) && (boardDetailsForm.get('arrayDimensionX')?.dirty || boardDetailsForm.get('arrayDimensionX')?.touched) ) {
                            <div class="error-message">
                              {{ validation.message }}
                            </div>
                          }
                        }
                      </div>
                    </div>
                    <span class="xmultiply">X</span>
                    <div class="col-6 wd50 pr-16">
                      <div style="display: flex;align-items: baseline;">
                        <input type="text" class="form-control" #arrayDimensionY id="arrayDimensionY" autocomplete="off" placeholder="Breadth" formControlName="arrayDimensionY" (change)="changeInSelectInput($event)" [(ngModel)]="boardDetailList.arrayDimensionY" required name="arrayDimensionY" (keyup)="commonService.removeRedBorder('arrayDimensionY')" (input)="onDecimalInput($event)"/>
                        <div  class="ofp-tooltip" id="boardPerArrayDimensionHide" style="display: none;">
                          <img class=" " src="assets/img/{{boardPerArrayDimensionImg}}.png" width="22" height="22" (mouseover)="showImageToolTip(boardPerArrayDimensionImg)" (mouseout)="hideImageToolTip(boardPerArrayDimensionImg)" style="margin-left: 5px;"/>
                          <span class="tooltiptext labelimagetooltip lableImageLabel-{{boardPerArrayDimensionImg}}"></span>
                        </div>
                      </div>
                      <div class="validation-errors">
                        @for (validation of board_details_validation_messages.arrayDimensionY; track validation) {
                          @if (boardDetailsForm.get('arrayDimensionY')?.hasError(validation.type) && (boardDetailsForm.get('arrayDimensionY')?.dirty || boardDetailsForm.get('arrayDimensionY')?.touched) ) {
                            <div class="error-message">
                              {{ validation.message }}
                            </div>
                          }
                        }
                      </div>
                    </div>
                  </div>
                </div>
              }
              <div class="row mb-3 mt-1point5">
                <div class="col-6 brd-label">
                  <div class="ofp-tooltip">
                    <label for="flexRigidBoardDiv" (mouseover)="showToolTip(33)" (mouseout)="hideToolTip(33)">Flex / Rigid-Flex Board:</label>
                    <span class="tooltiptext" id="boardDetailLabel-33"></span>
                  </div>
                </div>
                <div class="col-6 btn-group2" id="flexRigidBoardDiv" style="display: flex; align-items: baseline;">
                  <!-- OFP-3608 -->
                  <!-- <input (click)="switchOfButtons($event)" type="button" class="btn btn-switch " id="flexRigidBoardYes" value="Yes"/>
                  <input (click)="switchOfButtons($event)" type="button" class="btn btn-switch" id="flexRigidBoardNo" value="No" style="margin-right: 10px;"/> -->
                  <!-- <div class="col-6" style="display: flex; align-items: baseline;"> -->
                    <select class="form-select" id="flexRigidFlexBoard" formControlName="flexRigidFlexBoard" (change)="changeInSelectInput($event)"  [(ngModel)]="boardDetailList.flexRigidFlexBoard">
                    </select>
                    <div  class="ofp-tooltip">
                      <img class=" " src="assets/img/{{flexRigidBoardImg}}.png" width="22" height="22" (mouseover)="showImageToolTip(flexRigidBoardImg)" (mouseout)="hideImageToolTip(flexRigidBoardImg)" style="margin-left: 10px;"/>
                      <span class="tooltiptext labelimagetooltip lableImageLabel-{{flexRigidBoardImg}}"></span>
                    </div>
                  <!-- </div> -->
                </div>
              </div>
              <div class="row mb-3 mt-1point5">
                <div class="col-6 brd-label">
                  <div class="ofp-tooltip">
                    <label for="blindDiv" (mouseover)="showToolTip(34)" (mouseout)="hideToolTip(34)">Blind Vias?:</label>
                    <span class="tooltiptext" id="boardDetailLabel-34"></span>
                  </div>
                </div>
                <div class="col-6 btn-group3" id="blindDiv" style="display: flex; align-items: baseline;">
                  <input (click)="switchOfButtons($event)" type="button" class="btn btn-switch" id="blindBoardYes" value="Yes"/>
                  <input (click)="switchOfButtons($event)" type="button" class="btn btn-switch" id="blindBoardNo" value="No" style="margin-right: 10px;"/>
                  <div  class="ofp-tooltip">
                    <img class=" " src="assets/img/{{blindImg}}.png" width="22" height="22" (mouseover)="showImageToolTip(blindImg)" (mouseout)="hideImageToolTip(blindImg)"/>
                    <span class="tooltiptext labelimagetooltip lableImageLabel-{{blindImg}}"></span>
                  </div>
                </div>
              </div>
              <div class="row mb-3 mt-1point5">
                <div class="col-6 brd-label">
                  <div class="ofp-tooltip">
                    <label for="buriedDiv" (mouseover)="showToolTip(40)" (mouseout)="hideToolTip(40)">Buried Vias?:</label>
                    <span class="tooltiptext" id="boardDetailLabel-40"></span>
                  </div>
                </div>
                <div class="col-6 btn-group3" id="buriedDiv" style="display: flex; align-items: baseline;">
                  <input (click)="switchOfButtons($event)" type="button" class="btn btn-switch" id="buriedBoardYes" value="Yes"/>
                  <input (click)="switchOfButtons($event)" type="button" class="btn btn-switch" id="buriedBoardNo" value="No" style="margin-right: 10px;"/>
                  <div  class="ofp-tooltip">
                    <img class=" " src="assets/img/{{buriedImg}}.png" width="22" height="22" (mouseover)="showImageToolTip(buriedImg)" (mouseout)="hideImageToolTip(buriedImg)"/>
                    <span class="tooltiptext labelimagetooltip lableImageLabel-{{buriedImg}}"></span>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-6 col-lg-61 col-md-121 col-sm-121">
              <div class="row mb-3 mt-3">
                <div class="col-12 pcb-img-div">
                  @if (commonService.commonMainObj.fileUploadedData.topImage) {
                    <div class="col-6 text-center">
                      <div class="mb-3">PCB-Top Image</div>
                      <div style="border:0px solid red;" class="img-magnifier-container">
                        <img id="pcbImg1" class="pcb-img pcb_img_top" src="{{commonService.commonMainObj.topImagePath}}"/>
                      </div>
                      @if (commonService.commonMainObj.fileUploadedData.topImageHeight < 100 ||  commonService.commonMainObj.fileUploadedData.topImageWidth < 100) {
                        <div style="color: red;font-size: x-small;">Note: The provided image size is too small. To prevent blurring, image magnification is disabled.</div>
                      }
                    </div>
                  }
                  @if (commonService.commonMainObj.fileUploadedData.botImage) {
                    <div class="col-6 text-center">
                      <div class="mb-3">PCB-Bottom Image</div>
                      <div style="border:0px solid red;" class="img-magnifier-container">
                        <img id="pcbImg2" class="pcb-img pcb_img_bottom" src="{{commonService.commonMainObj.bottomImagePath}}" />
                      </div>
                      @if (commonService.commonMainObj.fileUploadedData.botImageHeight < 100 ||  commonService.commonMainObj.fileUploadedData.botImageWidth < 100) {
                        <div style="color: red;font-size: x-small;">Note: The provided image size is too small. To prevent blurring, image magnification is disabled.</div>
                      }
                    </div>
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>
<div class="board-details-container">
  <form class="needs-validation" novalidate [formGroup]="boardDetailsForm" autocomplete="off">
    <div class="card-container">
      <div class="container-title">PCB Fabrication Specification</div>
      <div class="row mb-3 mt-3" style="display: contents;">
        <div class="col-12 pl-2">
          <div class="row">
            <div class="mb-3 col-6">
              <div class="row mb-3 mtop-3">
                <div class="col-6 brd-label">
                  <div class="ofp-tooltip">
                    <label for="routeAndRetainDiv" (mouseover)="showToolTip(4)" (mouseout)="hideToolTip(4)" >Route and Retain:</label>
                    <span class="tooltiptext" id="boardDetailLabel-4"></span>
                  </div>
                </div>
                <div class="col-6 btn-group4" id="routeAndRetainDiv" style="display: flex; align-items: baseline;">
                  <input (click)="switchOfButtons($event)" type="button" class="btn btn-switch" id="routeAndRetainYes" value="Yes"/>
                  <input (click)="switchOfButtons($event)" type="button" class="btn btn-switch" id="routeAndRetainNo" value="No" style="margin-right: 10px;"/>
                  <div  class="ofp-tooltip">
                    <img class=" " src="assets/img/{{routeAndRetainImg}}.png" width="22" height="22" (mouseover)="showImageToolTip(routeAndRetainImg)" (mouseout)="hideImageToolTip(routeAndRetainImg)"/>
                    <span class="tooltiptext labelimagetooltip lableImageLabel-{{routeAndRetainImg}}"></span>
                  </div>
                </div>
              </div>
              <div class="row mb-3 mt-1point5">
                <div class="col-6 brd-label">
                  <div class="ofp-tooltip">
                    <label for="boardMaterial" (mouseover)="showToolTip(5)" (mouseout)="hideToolTip(5)">Board Material:</label>
                    <span class="tooltiptext" id="boardDetailLabel-5"></span>
                  </div>
                </div>
                <div class="col-6" style="display: flex; align-items: baseline;">
                  <select class="form-select" id="boardMaterial" #boardMaterial (change)="changeInSelectInput($event)" formControlName="boardMaterial" [(ngModel)]="boardDetailList.boardMaterial">
                  </select>
                  <div  class="ofp-tooltip">
                    <img class=" " src="assets/img/{{boardMaterialImg}}.png" width="22" height="22" (mouseover)="showImageToolTip(boardMaterialImg)" (mouseout)="hideImageToolTip(boardMaterialImg)" style="margin-left: 10px;"/>
                    <span class="tooltiptext labelimagetooltip lableImageLabel-{{boardMaterialImg}}"></span>
                  </div>
                </div>
              </div>
              <div class="row mb-3 mt-1point5">
                <div class="col-6 brd-label">
                  <div class="ofp-tooltip">
                    <label for="minHoleSize" (mouseover)="showToolTip(6)" (mouseout)="hideToolTip(6)">Minimum Hole Size:</label>
                    <span class="tooltiptext" id="boardDetailLabel-6"></span>
                  </div>
                </div>
                <div class="col-6" style="display: flex; align-items: baseline;">
                  <select class="form-select" id="minHoleSize" formControlName="minHoleSize" (change)="changeInSelectInput($event)"  [(ngModel)]="boardDetailList.minHoleSize">
                  </select>
                  <div  class="ofp-tooltip">
                    <img class=" " src="assets/img/{{minHoleSizeImg}}.png" width="22" height="22" (mouseover)="showImageToolTip(minHoleSizeImg)" (mouseout)="hideImageToolTip(minHoleSizeImg)" style="margin-left: 10px;"/>
                    <span class="tooltiptext labelimagetooltip lableImageLabel-{{minHoleSizeImg}}"></span>
                  </div>
                </div>
              </div>
              <div class="row mb-3 mt-1point5">
                <div class="col-6 brd-label ">
                  <div class="ofp-tooltip">
                    <label for="surfaceFinish" (mouseover)="showToolTip(7)" (mouseout)="hideToolTip(7)">Surface Finish:</label>
                    <span class="tooltiptext" id="boardDetailLabel-7"></span>
                  </div>
                </div>
                <div class="col-6" style="display: flex; align-items: baseline;">
                  <select class="form-select" id="surfaceFinish" #surfaceFinish (change)="changeInSelectInput($event)" formControlName="surfaceFinish" [(ngModel)]="boardDetailList.surfaceFinish">
                  </select>
                  <div  class="ofp-tooltip">
                    <img class=" " src="assets/img/{{surfaceFinishImg}}.png" width="22" height="22" (mouseover)="showImageToolTip(surfaceFinishImg)" (mouseout)="hideImageToolTip(surfaceFinishImg)" style="margin-left: 10px;"/>
                    <span class="tooltiptext labelimagetooltip lableImageLabel-{{surfaceFinishImg}}"></span>
                  </div>
                </div>
              </div>
            </div>
            <div class="mb-3 col-6">
              <div class="row mb-3 mtop-3">
                <div class="col-6 brd-label ">
                  <div class="ofp-tooltip">
                    <label for="scoringDiv" (mouseover)="showToolTip(10)" (mouseout)="hideToolTip(10)">Scoring:</label>
                    <span class="tooltiptext" id="boardDetailLabel-10"></span>
                  </div>
                </div>
                <div class="col-6 btn-group5" id="scoringDiv" style="display: flex; align-items: baseline;">
                  <input type="button" class="btn btn-switch" id="scoringYes" value="Yes" (click)="switchOfButtons($event)"/>
                  <input type="button" class="btn btn-switch " id="scoringNo" value="No" (click)="switchOfButtons($event)" style="margin-right: 10px;" />
                  <div  class="ofp-tooltip">
                    <img class=" " src="assets/img/{{scoringImg}}.png" width="22" height="22" (mouseover)="showImageToolTip(scoringImg)" (mouseout)="hideImageToolTip(scoringImg)"/>
                    <span class="tooltiptext right-img-tooltip lableImageLabel-{{scoringImg}}"></span>
                  </div>
                </div>
              </div>
              <div class="row mb-3 mt-1point5">
                <div class="col-6 brd-label ">
                  <div class="ofp-tooltip">
                    <label for="boardThickness" (mouseover)="showToolTip(11)" (mouseout)="hideToolTip(11)">Board Thickness:</label>
                    <span class="tooltiptext" id="boardDetailLabel-11"></span>
                  </div>
                </div>
                <div class="col-6" style="display: flex; align-items: baseline;">
                  <select class="form-select" id="boardThickness" formControlName="boardThickness" (change)="changeInSelectInput($event)" [(ngModel)]="boardDetailList.boardThickness">
                  </select>
                  <div  class="ofp-tooltip">
                    <img class=" " src="assets/img/{{boardThicknessImg}}.png" width="22" height="22" (mouseover)="showImageToolTip(boardThicknessImg)" (mouseout)="hideImageToolTip(boardThicknessImg)" style="margin-left: 10px;"/>
                    <span class="tooltiptext right-img-tooltip lableImageLabel-{{boardThicknessImg}}"></span>
                  </div>
                </div>
              </div>
              <div class="row mb-3 mt-1point5">
                <div class="col-6 brd-label ">
                  <div class="ofp-tooltip">
                    <label for="noOfHolesPerBoard" (mouseover)="showToolTip(12)" (mouseout)="hideToolTip(12)">Number of Holes (per board):<span style="color:red;padding-left: 3px;">*</span></label>
                    <span class="tooltiptext" id="boardDetailLabel-12"></span>
                  </div>
                </div>
                <div class="col-6">
                  <div style="display: flex; align-items: baseline;">
                    <input type="text" class="form-control" #noOfHolesPerBoard id="noOfHolesPerBoard" autocomplete="off" formControlName="noOfHolesPerBoard" (change)="changeInSelectInput($event)" [(ngModel)]="boardDetailList.noOfHolesPerBoard" required name="noOfHolesPerBoard" (keyup)="commonService.removeRedBorder('noOfHolesPerBoard')"/>
                    <div  class="ofp-tooltip" id="numberOfHolesTotipHide" style="display: none;">
                      <img class=" " src="assets/img/{{noOfHolesPerBoardsImg}}.png" width="22" height="22" (mouseover)="showImageToolTip(noOfHolesPerBoardsImg)" (mouseout)="hideImageToolTip(noOfHolesPerBoardsImg)" style="margin-left: 10px;"/>
                      <span class="tooltiptext right-img-tooltip lableImageLabel-{{noOfHolesPerBoardsImg}}"></span>
                    </div>
                  </div>

                  <div class="validation-errors">
                    @for (validation of board_details_validation_messages.noOfHolesPerBoard; track validation) {
                      @if (boardDetailsForm.get('noOfHolesPerBoard')?.hasError(validation.type) && (boardDetailsForm.get('noOfHolesPerBoard')?.dirty || boardDetailsForm.get('noOfHolesPerBoard')?.touched) ) {
                        <div class="error-message">
                          {{ validation.message }}
                        </div>
                      }
                    }
                  </div>
                </div>
              </div>
              <div class="row mb-3 mt-1point5">
                <div class="col-6 brd-label ">
                  <div class="ofp-tooltip">
                    <label for="goldFingersDiv" (mouseover)="showToolTip(13)" (mouseout)="hideToolTip(13)">Gold Fingers:</label>
                    <span class="tooltiptext" id="boardDetailLabel-13"></span>
                  </div>
                </div>
                <div class="col-6 btn-group6" id="goldFingersDiv" style="display: flex; align-items: baseline;">
                  <input type="button" class="btn btn-switch" id="goldFingersYes" value="Yes" (click)="switchOfButtons($event)"/>
                  <input type="button" class="btn btn-switch" id="goldFingersNo" value="No" (click)="switchOfButtons($event)" style="margin-right: 10px;"/>
                  <div  class="ofp-tooltip">
                    <img class=" " src="assets/img/{{goldFingersImg}}.png" width="22" height="22" (mouseover)="showImageToolTip(goldFingersImg)" (mouseout)="hideImageToolTip(goldFingersImg)"/>
                    <span class="tooltiptext right-img-tooltip lableImageLabel-{{goldFingersImg}}"></span>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card-container">
      <div class="container-sub-title ">Outer Layer</div>
      <div class="row mb-3 mt-3" style="display: contents;">
        <div class="col-12 pl-2">
          <div class="row" id="">
            <div class="mb-3 col-6">
              <div class="row mb-3 mtop-3">
                <div class="col-6 brd-label">
                  <div class="ofp-tooltip">
                    <label for="minimumTrace" (mouseover)="showToolTip(8)" (mouseout)="hideToolTip(8)">Minimum Trace:</label>
                    <span class="tooltiptext" id="boardDetailLabel-8"></span>
                  </div>
                </div>
                <div class="col-6" style="display: flex; align-items: baseline;">
                  <select class="form-select" id="minimumTrace" formControlName="minimumTrace" [(ngModel)]="boardDetailList.minimumTrace" (change)="changeInSelectInput($event)">
                  </select>
                  <div  class="ofp-tooltip">
                    <img class=" " src="assets/img/{{minimumTraceImg}}.png" width="22" height="22" (mouseover)="showImageToolTip(minimumTraceImg)" (mouseout)="hideImageToolTip(minimumTraceImg)" style="margin-left: 10px;"/>
                    <span class="tooltiptext labelimagetooltip lableImageLabel-{{minimumTraceImg}}"></span>
                  </div>
                </div>
              </div>
              <div class="row mb-3 mt-1point5">
                <div class="col-6 brd-label">
                  <div class="ofp-tooltip">
                    <label for="maxFinishCopperWeight" (mouseover)="showToolTip(9)" (mouseout)="hideToolTip(9)">Maximum Finish Copper Weight:</label>
                    <span class="tooltiptext" id="boardDetailLabel-9"></span>
                  </div>
                </div>
                <div class="col-6" style="display: flex; align-items: baseline;">
                  <select class="form-select" id="maxFinishCopperWeight" formControlName="maxFinishCopperWeight" [(ngModel)]="boardDetailList.maxFinishCopperWeight" (change)="changeInSelectInput($event)">
                  </select>
                  <div  class="ofp-tooltip">
                    <img class=" " src="assets/img/{{maxFinishCopperWeightImg}}.png" width="22" height="22" (mouseover)="showImageToolTip(maxFinishCopperWeightImg)" (mouseout)="hideImageToolTip(maxFinishCopperWeightImg)" style="margin-left: 10px;"/>
                    <span class="tooltiptext labelimagetooltip lableImageLabel-{{maxFinishCopperWeightImg}}"></span>
                  </div>
                </div>
              </div>
            </div>
            <div class="mb-3 col-6">
              <div class="row mb-3 mtop-3">
                <div class="col-6 brd-label ">
                  <div class="ofp-tooltip">
                    <label for="minimumSpace" (mouseover)="showToolTip(14)" (mouseout)="hideToolTip(14)">Minimum Space:</label>
                    <span class="tooltiptext" id="boardDetailLabel-14"></span>
                  </div>
                </div>
                <div class="col-6" style="display: flex; align-items: baseline;">
                  <select class="form-select" id="minimumSpace" formControlName="minimumSpace" [(ngModel)]="boardDetailList.minimumSpace"  (change)="changeInSelectInput($event)"></select>
                  <div  class="ofp-tooltip">
                    <img class=" " src="assets/img/{{minimumSpaceImg}}.png" width="22" height="22" (mouseover)="showImageToolTip(minimumSpaceImg)" (mouseout)="hideImageToolTip(minimumSpaceImg)" style="margin-left: 10px;"/>
                    <span class="tooltiptext right-img-tooltip lableImageLabel-{{minimumSpaceImg}}"></span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card-container" id="innerLayerContent" [hidden]="hideInnerLayerContent">
      <div class="container-sub-title ">Inner Layer</div>
      <div class="row mb-3 mt-3" style="display: contents;">
        <div class="col-12 pl-2">
          <div class="row" id="">
            <div class="mb-3 col-6">
              <div class="row mb-3 mtop-3">
                <div class="col-6 brd-label">
                  <div class="ofp-tooltip">
                    <label for="minimumTrace" (mouseover)="showToolTip(27)" (mouseout)="hideToolTip(27)">Minimum Trace:</label>
                    <span class="tooltiptext" id="boardDetailLabel-27"></span>
                  </div>
                </div>
                <div class="col-6" style="display: flex; align-items: baseline;">
                  <select class="form-select" id="innerMinimumTrace" formControlName="innerMinimumTrace" (change)="changeInSelectInput($event)" [(ngModel)]="boardDetailList.innerMinimumTrace">
                  </select>
                  <div  class="ofp-tooltip">
                    <img class=" " src="assets/img/{{innerMinimumTraceImg}}.png" width="22" height="22" (mouseover)="showImageToolTip(innerMinimumTraceImg)" (mouseout)="hideImageToolTip(innerMinimumTraceImg)" style="margin-left: 10px;"/>
                    <span class="tooltiptext labelimagetooltip lableImageLabel-{{innerMinimumTraceImg}}"></span>
                  </div>
                </div>
              </div>
              <div class="row mb-3 mt-1point5">
                <div class="col-6 brd-label">
                  <div class="ofp-tooltip">
                    <label for="innerMaxFinishCopperWeight" (mouseover)="showToolTip(28)" (mouseout)="hideToolTip(28)">Maximum Finish Copper Weight:</label>
                    <span class="tooltiptext" id="boardDetailLabel-28"></span>
                  </div>
                </div>
                <div class="col-6" style="display: flex; align-items: baseline;">
                  <select class="form-select" id="innerMaxFinishCopperWeight" formControlName="innerMaxFinishCopperWeight" (change)="changeInSelectInput($event)" [(ngModel)]="boardDetailList.innerMaxFinishCopperWeight">
                  </select>
                  <div  class="ofp-tooltip">
                    <img class=" " src="assets/img/{{innerMaxFinishCopperWeightImg}}.png" width="22" height="22" (mouseover)="showImageToolTip(innerMaxFinishCopperWeightImg)" (mouseout)="hideImageToolTip(innerMaxFinishCopperWeightImg)" style="margin-left: 10px;"/>
                    <span class="tooltiptext labelimagetooltip lableImageLabel-{{innerMaxFinishCopperWeightImg}}"></span>
                  </div>
                </div>
              </div>
            </div>
            <div class="mb-3 col-6">
              <div class="row mb-3 mtop-3">
                <div class="col-6 brd-label ">
                  <div class="ofp-tooltip">
                    <label for="innerMinimumSpace" (mouseover)="showToolTip(29)" (mouseout)="hideToolTip(29)">Minimum Space:</label>
                    <span class="tooltiptext" id="boardDetailLabel-29"></span>
                  </div>
                </div>
                <div class="col-6" style="display: flex; align-items: baseline;">
                  <select class="form-select" id="innerMinimumSpace" formControlName="innerMinimumSpace" (change)="changeInSelectInput($event)" [(ngModel)]="boardDetailList.innerMinimumSpace"></select>
                  <div  class="ofp-tooltip">
                    <img class=" " src="assets/img/{{innerMinimumSpaceImg}}.png" width="22" height="22" (mouseover)="showImageToolTip(innerMinimumSpaceImg)" (mouseout)="hideImageToolTip(innerMinimumSpaceImg)" style="margin-left: 10px;"/>
                    <span class="tooltiptext right-img-tooltip lableImageLabel-{{innerMinimumSpaceImg}}"></span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card-container">
      <div class="container-sub-title ">
        <div class="ofp-tooltip" style="font-weight: normal;">
          <span style="font-weight: bold !important;"  (mouseover)="showToolTip(35)" (mouseout)="hideToolTip(35)">Solder Mask</span>
          <span class="tooltiptext" id="boardDetailLabel-35"></span>
        </div>
      </div>
      <div class="row mb-3 mt-3" style="display: contents;">
        <div class="col-12 pl-2">
          <div class="row sub-selection-btns" id="solder-mask-div">
            <div  style="display: flex; align-items: baseline; justify-content: center;">
              <input type="button" class="btn btn-switch " id="solderMaskYes" value="Yes" (click)="switchOfButtons($event)"/>
              <input type="button" class="btn btn-switch " id="solderMaskNo" value="No" (click)="switchOfButtons($event)" style="margin-right: 10px;"/>
              <div  class="ofp-tooltip">
                <img class=" " src="assets/img/{{solderMaskImg}}.png" width="22" height="22" (mouseover)="showImageToolTip(solderMaskImg)" (mouseout)="hideImageToolTip(solderMaskImg)"/>
                <span class="tooltiptext labelimagetooltip lableImageLabel-{{solderMaskImg}}"></span>
              </div>
            </div>
          </div>
          <div class="row" id="fabSolderMaskSection">
            <div class="mb-3 col-6">
              <div class="row mb-3 mtop-3">
                <div class="col-6 brd-label">
                  <div class="ofp-tooltip">
                    <label for="solderMaskSides" (mouseover)="showToolTip(15)" (mouseout)="hideToolTip(15)">Sides:</label>
                    <span class="tooltiptext" id="boardDetailLabel-15"></span>
                  </div>
                </div>
                <div class="col-6" style="display: flex; align-items: baseline;">
                  <select class="form-select" id="solderMaskSides" formControlName="solderMaskSides" (change)="changeInSelectInput($event)" [(ngModel)]="boardDetailList.solderMaskSides"></select>
                  <div  class="ofp-tooltip">
                    <img class=" " src="assets/img/{{solderMaskSidesImg}}.png" width="22" height="22" (mouseover)="showImageToolTip(solderMaskSidesImg)" (mouseout)="hideImageToolTip(solderMaskSidesImg)" style="margin-left: 10px;"/>
                    <span class="tooltiptext labelimagetooltip lableImageLabel-{{solderMaskSidesImg}}"></span>
                  </div>
                </div>
              </div>
              <div class="row mb-3 mt-1point5">
                <div class="col-6 brd-label ">
                  <div class="ofp-tooltip">
                    <label for="solderMaskColor" (mouseover)="showToolTip(16)" (mouseout)="hideToolTip(16)">Color:</label>
                    <span class="tooltiptext" id="boardDetailLabel-16"></span>
                  </div>
                </div>
                <div class="col-6" style="display: flex; align-items: baseline;">
                  <select class="form-select" id="solderMaskColor" formControlName="solderMaskColor" (change)="changeInSelectInput($event)" [(ngModel)]="boardDetailList.solderMaskColor"></select>
                  <div  class="ofp-tooltip">
                    <img class=" " src="assets/img/{{solderMaskColorImg}}.png" width="22" height="22" (mouseover)="showImageToolTip(solderMaskColorImg)" (mouseout)="hideImageToolTip(solderMaskColorImg)" style="margin-left: 10px;"/>
                    <span class="tooltiptext labelimagetooltip lableImageLabel-{{solderMaskColorImg}}"></span>
                  </div>
                </div>
              </div>
            </div>
            <div class="mb-3 col-6">
              <div class="row mb-3 mtop-3">
                <div class="col-6 brd-label ">
                  <div class="ofp-tooltip">
                    <label for="solderMaskTypes" (mouseover)="showToolTip(17)" (mouseout)="hideToolTip(17)">Type:</label>
                    <span class="tooltiptext" id="boardDetailLabel-17">
                    </span>
                  </div>
                </div>
                <div class="col-6" style="display: flex; align-items: baseline;">
                  <select class="form-select" id="solderMaskTypes" formControlName="solderMaskTypes" (change)="changeInSelectInput($event)" [(ngModel)]="boardDetailList.solderMaskTypes"></select>
                  <div  class="ofp-tooltip">
                    <img class=" " src="assets/img/{{solderMaskTypesImg}}.png" width="22" height="22" (mouseover)="showImageToolTip(solderMaskTypesImg)" (mouseout)="hideImageToolTip(solderMaskTypesImg)" style="margin-left: 10px;"/>
                    <span class="tooltiptext right-img-tooltip lableImageLabel-{{solderMaskTypesImg}}"></span>
                  </div>
                </div>
              </div>
              <div class="row mb-3 mt-1point5">
                <div class="col-6 brd-label ">
                  <div class="ofp-tooltip">
                    <label for="solderMaskFinish" (mouseover)="showToolTip(18)" (mouseout)="hideToolTip(18)" >Finish:</label>
                    <span class="tooltiptext" id="boardDetailLabel-18"></span>
                  </div>
                </div>
                <div class="col-6" style="display: flex; align-items: baseline;">
                  <select class="form-select" id="solderMaskFinish" formControlName="solderMaskFinish" (change)="changeInSelectInput($event)" [(ngModel)]="boardDetailList.solderMaskFinish"></select>
                  <div  class="ofp-tooltip">
                    <img class=" " src="assets/img/{{solderMaskFinishImg}}.png" width="22" height="22" (mouseover)="showImageToolTip(solderMaskFinishImg)" (mouseout)="hideImageToolTip(solderMaskFinishImg)" style="margin-left: 10px;"/>
                    <span class="tooltiptext right-img-tooltip lableImageLabel-{{solderMaskFinishImg}}"></span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card-container">
      <div class="container-sub-title ">
        <div class="ofp-tooltip" style="font-weight: normal;">
          <span style="font-weight: bold !important;" (mouseover)="showToolTip(36)" (mouseout)="hideToolTip(36)">Silk Screen</span>
          <span class="tooltiptext" id="boardDetailLabel-36"></span>
        </div>
      </div>
      <div class="row mb-3 mt-3" style="display: contents;">
        <div class="col-12 pl-2">
          <div class="row sub-selection-btns">
            <div  style="display: flex; align-items: baseline; justify-content: center;">
              <input type="button" class="btn btn-switch" id="silkScreenYes" value="Yes" (click)="switchOfButtons($event)"/>
              <input type="button" class="btn btn-switch" id="silkScreenNo" value="No" (click)="switchOfButtons($event)" style="margin-right: 10px;"/>
              <div  class="ofp-tooltip">
                <img class=" " src="assets/img/{{silkScreenImg}}.png" width="22" height="22" (mouseover)="showImageToolTip(silkScreenImg)" (mouseout)="hideImageToolTip(silkScreenImg)"/>
                <span class="tooltiptext labelimagetooltip lableImageLabel-{{silkScreenImg}}"></span>
              </div>
            </div>
          </div>
          <div class="row" id="fabSilkScreenSection">
            <div class="mb-3 col-6">
              <div class="row mb-3 mtop-3">
                <div class="col-6 brd-label ">
                  <div class="ofp-tooltip">
                    <label for="silkScreenSides" (mouseover)="showToolTip(19)" (mouseout)="hideToolTip(19)">Sides:</label>
                    <span class="tooltiptext" id="boardDetailLabel-19"></span>
                  </div>
                </div>
                <div class="col-6" style="display: flex; align-items: baseline;">
                  <select class="form-select" id="silkScreenSides" formControlName="silkScreenSides" (change)="changeInSelectInput($event)" [(ngModel)]="boardDetailList.silkScreenSides"></select>
                  <div  class="ofp-tooltip">
                    <img class=" " src="assets/img/{{silkScreenSidesImg}}.png" width="22" height="22" (mouseover)="showImageToolTip(silkScreenSidesImg)" (mouseout)="hideImageToolTip(silkScreenSidesImg)" style="margin-left: 10px;"/>
                    <span class="tooltiptext labelimagetooltip lableImageLabel-{{silkScreenSidesImg}}"></span>
                  </div>
                </div>
              </div>
              <!-- <div class="row mb-3 mt-1point5">
              <div class="col-6 brd-label ">
                <div class="ofp-tooltip">
                  <label for="silkScreenMethod" >Method:</label>
                </div>
              </div>
              <div class="col-6">
                <select class="form-select" id="silkScreenMethod" formControlName="silkScreenMethod" [(ngModel)]="boardDetailList.silkScreenMethod">
                  <option value="Inkjet">Inkjet</option>
                </select>
              </div>
            </div> -->
          </div>
          <div class="mb-3 col-6">
            <div class="row mb-3 mtop-3">
              <div class="col-6 brd-label ">
                <div class="ofp-tooltip">
                  <label for="silkScreenColor" (mouseover)="showToolTip(20)" (mouseout)="hideToolTip(20)">Color:</label>
                  <span class="tooltiptext" id="boardDetailLabel-20"></span>
                </div>
              </div>
              <div class="col-6" style="display: flex; align-items: baseline;">
                <select class="form-select" id="silkScreenColor" formControlName="silkScreenColor" (change)="changeInSelectInput($event)" [(ngModel)]="boardDetailList.silkScreenColor"></select>
                <div  class="ofp-tooltip">
                  <img class=" " src="assets/img/{{silkScreenColorImg}}.png" width="22" height="22" (mouseover)="showImageToolTip(silkScreenColorImg)" (mouseout)="hideImageToolTip(silkScreenColorImg)" style="margin-left: 10px;"/>
                  <span class="tooltiptext right-img-tooltip lableImageLabel-{{silkScreenColorImg}}"></span>
                </div>
              </div>
            </div>
          </div>


        </div>
      </div>
    </div>
  </div>
  <div class="card-container">
    <div class="container-sub-title ">
      <div class="ofp-tooltip" style="font-weight: normal;">
        <span style="font-weight: bold !important;" >Additional PCB Specifications</span>
        <!-- <span class="tooltiptext" id="boardDetailLabel-36"></span> -->
      </div>
    </div>
    <!-- <div class="container-sub-title ">
      @if (commonService.commonMainObj.backToBoardDetails && commonService.commonMainObj.fileUploadedData.boardParam.counterSink == 'Yes') {
        <span>Additional PCB Specifications</span>
      }
    </div> -->
    <div class="row mb-3 mt-3" style="display: contents;">
      <div class="col-12 pl-2">
        <div class="row">
          <div class="col-6">
            <div class="row mb-3 mtop-3">
            <div class="col-6 brd-label">
              <!-- <label for="viaInPads">PCB has <a style="color:#0787bc;cursor: pointer;text-decoration: underline;" (click)=" openViaInPad(via_in_pad)">Via-in-pad</a> features?</label> -->
              <label for="viaInPads">PCB has <a style="color:#0787bc;cursor: pointer;text-decoration: underline;" href="{{apiService.Via_In_Pad_URL}}" target="_blank">Via-in-pad</a> features?</label>
            </div>
            <div class="col-6 btn-group7" id="viaInPads">
              <input type="button" class="btn btn-switch " id="viaInPadsYes" value="Yes" (click)="switchOfButtons($event)"/>
              <input type="button" class="btn btn-switch " id="viaInPadsNo" value="No" (click)="switchOfButtons($event)" style="margin-right: 10px;"/>
              <div  class="ofp-tooltip">
                <img class=" " src="assets/img/{{viaInPadImg}}.png" width="22" height="22" (mouseover)="showImageToolTip(viaInPadImg)" (mouseout)="hideImageToolTip(viaInPadImg)"/>
                <span class="tooltiptext labelimagetooltip lableImageLabel-{{viaInPadImg}}"></span>
              </div>
            </div>
          </div>
          <!-- <div class="row mb-3 mtop-3">
            <div class="col-6 brd-label">
              <div class="ofp-tooltip">
                <label for="allowVendorMarkings" (mouseover)="showToolTip(21)" (mouseout)="hideToolTip(21)" >Allow vendor markings on boards?</label>
                <span class="tooltiptext" id="boardDetailLabel-21"></span>
              </div>
            </div>
            <div class="col-6" style="display: flex; align-items: baseline;">
              <input (click)="switchOfButtons($event)" type="button" class="btn btn-switch "   id="allowVendorMarkingsYes" value="Yes"/>
              <input (click)="switchOfButtons($event)" type="button" class="btn btn-switch " id="allowVendorMarkingsNo" value="No" style="margin-right: 10px;"/>
              <div  class="ofp-tooltip">
                <img class=" " src="assets/img/{{allowVendorMarkingImg}}.png" width="22" height="22" (mouseover)="showImageToolTip(allowVendorMarkingImg)" (mouseout)="hideImageToolTip(allowVendorMarkingImg)"/>
                <span class="tooltiptext labelimagetooltip lableImageLabel-{{allowVendorMarkingImg}}"></span>
              </div>
            </div>
          </div> -->
          <div class="row mb-3 mt-4">
            <div class="col-6 brd-label">
              <div class="ofp-tooltip">
                <label for="controlledImpedance" (mouseover)="showToolTip(22)" (mouseout)="hideToolTip(22)">Controlled impedance:</label>
                <span class="tooltiptext" id="boardDetailLabel-22"></span>
              </div>
            </div>
            <div class="col-6" style="display: flex; align-items: baseline;">
              <select class="form-select" id="controlledImpedance" formControlName="controlledImpedance" (change)="changeInSelectInput($event)" [(ngModel)]="boardDetailList.controlledImpedance"></select>
              <div  class="ofp-tooltip">
                <img class=" " src="assets/img/{{controlledImpedanceImg}}.png" width="22" height="22" (mouseover)="showImageToolTip(controlledImpedanceImg)" (mouseout)="hideImageToolTip(controlledImpedanceImg)" style="margin-left: 10px;"/>
                <span class="tooltiptext labelimagetooltip lableImageLabel-{{controlledImpedanceImg}}"></span>
              </div>
            </div>
          </div>
            <div class="row mb-3 mt-4">
            <div class="col-6 brd-label ">
              <div class="ofp-tooltip">
                <label for="rohs" (mouseover)="showToolTip(24)" (mouseout)="hideToolTip(24)">Allow RoHS Marking?</label>
                <span class="tooltiptext" id="boardDetailLabel-24"></span>
              </div>
            </div>
            <div class="col-6">
              <div class="ofp-tooltip">
                <input type="button" class="btn btn-switch " id="rohsYes" value="Yes" (click)="switchOfRohsButtons($event)"/>
                <!-- <span  class="tooltiptext" id="rohsToolTip">RoHS Marking is allowed only when 'Board material' =  FR4- lead free' / 'Nan Ya NP-175' and 'Surface Finish' = 'hard gold' / 'immersion silver' / 'ENIG'</span> -->
              </div>
              <input type="button" class="btn btn-switch " id="rohsNo" value="No" (click)="switchOfRohsButtons($event)" style="margin-right: 10px;"/>
              <div  class="ofp-tooltip">
                <img class=" " src="assets/img/{{rohsImg}}.png" width="22" height="22" (mouseover)="showImageToolTip(rohsImg)" (mouseout)="hideImageToolTip(rohsImg)"/>
                <span class="tooltiptext right-img-tooltip labelimagetooltip lableImageLabel-{{rohsImg}}"></span>
              </div>
            </div>
          </div>
          <div class="row mb-3" style="margin-top: 25px;">
              <div class="col-6 brd-label">
                <div class="ofp-tooltip">
                  <label for="allowVendorMarkings" (mouseover)="showToolTip(21)" (mouseout)="hideToolTip(21)" >Allow vendor markings on boards?</label>
                  <span class="tooltiptext" id="boardDetailLabel-21"></span>
                </div>
              </div>
              <div class="col-6" style="display: flex; align-items: baseline;">
                <input (click)="switchOfButtons($event)" type="button" class="btn btn-switch "   id="allowVendorMarkingsYes" value="Yes"/>
                <input (click)="switchOfButtons($event)" type="button" class="btn btn-switch " id="allowVendorMarkingsNo" value="No" style="margin-right: 10px;"/>
                <div  class="ofp-tooltip">
                  <img class=" " src="assets/img/{{allowVendorMarkingImg}}.png" width="22" height="22" (mouseover)="showImageToolTip(allowVendorMarkingImg)" (mouseout)="hideImageToolTip(allowVendorMarkingImg)"/>
                  <span class="tooltiptext labelimagetooltip lableImageLabel-{{allowVendorMarkingImg}}"></span>
                </div>
              </div>
            </div>
          </div>
          <div class="col-6">
        
        <div class="row mb-3 mtop-3">
          <div class="col-6 brd-label ">
            <div class="ofp-tooltip">
              <label for="internalSlotsCutOut" (mouseover)="showToolTip(25)" (mouseout)="hideToolTip(25)">Internal Slots or Internal Cutouts?</label>
              <span class="tooltiptext" id="boardDetailLabel-25"></span>
            </div>
          </div>
          <div class="col-6" style="display: flex; align-items: baseline;">
            <select class="form-select" id="internalSlotsCutOut" formControlName="internalSlotsCutOut" (change)="changeInSelectInput($event)" [(ngModel)]="boardDetailList.internalSlotsCutOut"></select>
            <div  class="ofp-tooltip">
              <img class=" " src="assets/img/{{internalSlotsCutOutImg}}.png" width="22" height="22" (mouseover)="showImageToolTip(internalSlotsCutOutImg)" (mouseout)="hideImageToolTip(internalSlotsCutOutImg)" style="margin-left: 10px;"/>
              <span class="tooltiptext right-img-tooltip lableImageLabel-{{internalSlotsCutOutImg}}"></span>
            </div>
          </div>
        </div>
        @if (commonService.commonMainObj.backToBoardDetails && commonService.commonMainObj.fileUploadedData.boardParam_fast_pcb.controlled_dielectric == 'Yes') {
        <div class="row mb-3 mt-1point5">
          <div class="col-6 brd-label ">
            <div class="ofp-tooltip">
              <label for="rohs" (mouseover)="showToolTip(42)" (mouseout)="hideToolTip(42)">Controlled Dielectric</label>
              <span class="tooltiptext" id="boardDetailLabel-42"></span>
            </div>
          </div>
          <div class="col-6" style="display: flex; align-items: baseline;">
            <div class="ofp-tooltip">
              <input type="button" class="btn btn-switch " id="controlledDielectricYes" value="Yes" (click)="switchOfControlledDielectricButtons($event)"/>
            </div>
            <input type="button" class="btn btn-switch " id="controlledDielectricNo" value="No" (click)="switchOfControlledDielectricButtons($event)" style="margin-right: 10px;"/>
            <div  class="ofp-tooltip">
              <img class=" " src="assets/img/{{controlledDielectricImg}}.png" width="22" height="22" (mouseover)="showImageToolTip(controlledDielectricImg)" (mouseout)="hideImageToolTip(controlledDielectricImg)"/>
              <span class="tooltiptext right-img-tooltip labelimagetooltip lableImageLabel-{{controlledDielectricImg}}"></span>
            </div>
          </div>
        </div>
        }
        @if (commonService.commonMainObj.fileUploadedData.boardParam_fast_pcb.counter_bore == 'Yes' || commonService.commonMainObj.fileUploadedData.boardParam_fast_pcb.controlled_dielectric == 'Yes') {
          @if (commonService.commonMainObj.backToBoardDetails && commonService.commonMainObj.fileUploadedData.boardParam_fast_pcb.counter_bore == 'Yes') {
          <div class="row mb-3 mt-1point5">
          <div class="col-6 brd-label ">
            <div class="ofp-tooltip" style="padding-left: 15px;">
              <label for="rohs" (mouseover)="showToolTip(41)" (mouseout)="hideToolTip(41)">Counter Bore</label>
              <span class="tooltiptext" id="boardDetailLabel-41"></span>
            </div>
          </div>
          <div class="col-6" style="display: flex; align-items: baseline;">
            <div class="ofp-tooltip">
                  <input type="button" class="btn btn-switch " id="counterBoreYes" value="Yes" (click)="switchOfCounterBoreButtons($event)"/>
                </div>
                <input type="button" class="btn btn-switch " id="counterBoreNo" value="No" (click)="switchOfCounterBoreButtons($event)" style="margin-right: 10px;"/>
                <div  class="ofp-tooltip">
                  <img class=" " src="assets/img/{{counterBoreImg}}.png" width="22" height="22" (mouseover)="showImageToolTip(counterBoreImg)" (mouseout)="hideImageToolTip(counterBoreImg)"/>
                  <span class="tooltiptext right-img-tooltip labelimagetooltip lableImageLabel-{{counterBoreImg}}"></span>
                </div>
          </div>
          </div>
          }
      }
      @if (commonService.commonMainObj.backToBoardDetails && commonService.commonMainObj.fileUploadedData.boardParam.counterSink == 'Yes') {
          <div class="row mb-3 mt-1point5">
            <div class="col-6 brd-label">
              <div class="ofp-tooltip">
                <label for="rohs" (mouseover)="showToolTip(30)" (mouseout)="hideToolTip(30)">Counter Sink</label>
                <span class="tooltiptext" id="boardDetailLabel-30"></span>
              </div>
            </div>
            <div class="col-6" style="display: flex; align-items: baseline;">
              <div class="ofp-tooltip">
                <input type="button" class="btn btn-switch " id="counterSinkYes" value="Yes" (click)="switchOfCounterSinkButtons($event)"/>
              </div>
              <input type="button" class="btn btn-switch " id="counterSinkNo" value="No" (click)="switchOfCounterSinkButtons($event)" style="margin-right: 10px;"/>
              <div  class="ofp-tooltip">
                <img class=" " src="assets/img/{{counterSinkImg}}.png" width="22" height="22" (mouseover)="showImageToolTip(counterSinkImg)" (mouseout)="hideImageToolTip(counterSinkImg)"/>
                <span class="tooltiptext right-img-tooltip labelimagetooltip lableImageLabel-{{counterSinkImg}}"></span>
              </div>
            </div>
          </div>
        }

        <div class="row mb-3 mt-1point5" style="display: none;">
          <div class="col-6 brd-label">
            <div class="ofp-tooltip">
              <label for="electricalTestingDiv" (mouseover)="showToolTip(26)" (mouseout)="hideToolTip(26)">Electrical Testing Required?</label>
              <span class="tooltiptext" id="boardDetailLabel-26"></span>
            </div>
          </div>
          <div class="col-6 btn-group9" id="electricalTestingDiv">
            <input type="button" class="btn btn-switch" id="electricalTestingYes" value="Yes" (click)="switchOfTestingButtons($event)"/>
            <div class="ofp-tooltip">
              <input type="button" class="btn btn-switch" id="electricalTestingNo" value="No" (click)="switchOfTestingButtons($event)"/>
              <span class="tooltiptext" id="testingToolTip">If your PCB has more than 6 layers, Electrical Testing is mandatory.</span>
            </div>
            <!-- <div class="ofp-tooltip" *ngIf="layerBelow6  == true">
            <input type="button" class="btn btn-switch btn-gray " id="electricalTestingNo" value="No" (click)="switchOfButtons($event)"/>
            <span class="tooltiptext" id="boardDetailLabel-27"></span>
          </div> -->
        </div>
      </div>
          </div>
        </div>
      </div>
    </div>
  </div>
<div class="card-container" style="border-top: 1px dashed #AAA;">
    <div class="row mb-3 mt-3" style="display: contents;">
      <div class="col pl-2">
        <div class="row mb-3  mtop-3">
            <div class="col-6 brd-label ">
              <div class="ofp-tooltip">
                <label for="needItarComplianceDiv" (mouseover)="showToolTip(23)" (mouseout)="hideToolTip(23)">Need ITAR Compliance?<span style="color:red;padding-left: 3px;">*</span></label>
                <span class="largeTooltiptext itarTooltip" id="boardDetailLabel-23"></span>
              </div>
            </div>
            <div class="col-6" id="needItarComplianceDiv">
              <ul class="list-group" style="display: block;"  id="itarRadioButtonGroup" >
                <li class="list-group-item border-0 dib" style="margin-top: 0px">
                  <input type="radio" class="form-check-input me-1" value="1" #itarYes id="itarYes" name="itar" (change)="changeItarToSwitchButtons($event)" />
                  <label class="form-check-label" for="itarYes" >Yes</label>
                </li>
                <li class="list-group-item border-0 dib">
                  <input type="radio" class="form-check-input me-1" value="2" #itarNo id="itarNo" name="itar" (change)="changeItarToSwitchButtons($event)"/>
                  <label class="form-check-label" for="itarNo">No</label>
                </li>
              </ul>
              <div class="btn-group8" id="itarSwitchButtonGroup" style="display: none;">
                <div style="display: flex; align-items: baseline;">
                  <input type="button" class="btn btn-switch btn-green active" id="itarSitchYes" value="Yes" (click)="switchOfButtons($event)"/>
                  <input type="button" class="btn btn-switch btn-gray " id="itarSitchNo" value="No" (click)="switchOfButtons($event)" style="margin-right: 10px;"/>
                  <div  class="ofp-tooltip">
                    <img class=" " src="assets/img/{{itarSitchImg}}.png" width="22" height="22" (mouseover)="showImageToolTip(itarSitchImg)" (mouseout)="hideImageToolTip(itarSitchImg)"/>
                    <span class="tooltiptext labelimagetooltip lableImageLabel-{{itarSitchImg}}"></span>
                  </div>
                </div>
              </div>
            </div>
        </div>
        @if(this.commonService.commonMainObj.itarConditionCheck == true){
          <div class="row mb-3 mt-1point5" id="itarYesSec">
            <div class="col-6 brd-label ">
              <div class="ofp-tooltip">
                <label for="usmlOrEccn" ><div>USML/ECCN</div> <div style="font-size:small">(e.g. 9E515 or USML XIV, etc.)</div></label>
                <!-- <span class="tooltiptext" id="boardDetailLabel-12"></span> -->
              </div>
            </div>
            <div class="col-6">
              <div style="display: flex; align-items: baseline;">
                <input type="text" class="form-control" #usmlOrEccn id="usmlOrEccn" autocomplete="off" formControlName="usmlOrEccn" (change)="changeInSelectInput($event)" [(ngModel)]="boardDetailList.usmlOrEccn" name="USML/ECCN" (keyup)="commonService.removeRedBorder('usmlOrEccn')"/>
                <div  class="ofp-tooltip" id="usmlOrEccnTotipHide" style="display: none;">
                  <img class=" " src="assets/img/{{usmlOrEccnImg}}.png" width="22" height="22" (mouseover)="showImageToolTip(usmlOrEccnImg)" (mouseout)="hideImageToolTip(usmlOrEccnImg)" style="margin-left: 10px;"/>
                  <span class="tooltiptext right-img-tooltip lableImageLabel-{{usmlOrEccnImg}}"></span>
                </div>
              </div>
            </div>
          </div>
        }
      </div>
      <div class="col">
        <div class="row mb-3  mtop-3">
          <div class="col-6 brd-label">
            <div class="ofp-tooltip">
              <label for="quantityOfIndividualBoardsDiv" (mouseover)="showToolTip(37)" (mouseout)="hideToolTip(37)">Quantity of Individual Boards:</label>
              <span class="tooltiptext" id="boardDetailLabel-37"></span>
            </div>
          </div>
          <div class="col-6" id="quantityOfIndividualBoardsDiv" style="display: flex;align-items: baseline;padding-left: 7px;">
            <input #boardQty1 type="text" class="form-control m-5px wd-100" id="boardQty1" autocomplete="off" formControlName="boardQty1" (change)="changeInSelectInput($event)" [(ngModel)]="boardDetailList.boardQty1" name="boardQty1" (keyup)="removeRedBorder('boardQty1',$event,boardDetailList.boardQty1)"/>
            <input #boardQty2 type="text" class="form-control m-5px wd-100" id="boardQty2" autocomplete="off" formControlName="boardQty2" (change)="changeInSelectInput($event)" [(ngModel)]="boardDetailList.boardQty2"  name="boardQty2" (keyup)="removeRedBorder('boardQty2',$event,boardDetailList.boardQty2)"/>
            <!-- <input type="text" class="form-control m-5px wd-100" id="boardQty3" autocomplete="off" formControlName="boardQty3" [(ngModel)]="boardDetailList.boardQty3" required name="boardQty3" />
            <input type="text" class="form-control m-5px wd-100" id="boardQty4" autocomplete="off" formControlName="boardQty4" [(ngModel)]="boardDetailList.boardQty4" required name="boardQty4"/> -->
            <div  class="ofp-tooltip" id="quantityOfIndividualBoardsImgHide" style="display: none;">
              <img class=" " src="assets/img/{{quantityOfIndividualBoardsImg}}.png" width="22" height="22" (mouseover)="showImageToolTip(quantityOfIndividualBoardsImg)" (mouseout)="hideImageToolTip(quantityOfIndividualBoardsImg)"/>
              <span class="tooltiptext labelimagetooltip lableImageLabel-{{quantityOfIndividualBoardsImg}}"></span>
            </div>
          </div>
        </div>
        @if(this.commonService.commonMainObj.itarConditionCheck == true){
          <div class="row mb-3 mt-1point5" id="itarYesSec">
            <div class="col-6 brd-label ">
              <div class="ofp-tooltip">
                <label for="endUseOfPcbAssembly"><div>End Use of PCB/Assembly<span style="color:red;padding-left: 3px;">*</span></div> <div style="font-size:small">(e.g. radar, or mobile phone, or automotive, etc.)</div></label>
              </div>
            </div>
            <div class="col-6" style="display: flex; align-items: baseline;">
              <select class="form-select" id="endUseOfPcbAssembly" formControlName="endUseOfPcbAssembly" (change)="changeInSelectInput($event)" [(ngModel)]="boardDetailList.endUseOfPcbAssembly"></select>
              <div  class="ofp-tooltip">
                <img class=" " src="assets/img/{{endUseOfPcbAssemblyImg}}.png" width="22" height="22" (mouseover)="showImageToolTip(endUseOfPcbAssemblyImg)" (mouseout)="hideImageToolTip(endUseOfPcbAssemblyImg)" style="margin-left: 10px;"/>
                <span class="tooltiptext right-img-tooltip lableImageLabel-{{endUseOfPcbAssemblyImg}}"></span>
              </div>
              <div class="validation-errors">
                @for (validation of board_details_validation_messages.endUseOfPcbAssembly; track validation) {
                  @if (boardDetailsForm.get('endUseOfPcbAssembly')?.hasError(validation.type) && (boardDetailsForm.get('endUseOfPcbAssembly')?.dirty || boardDetailsForm.get('endUseOfPcbAssembly')?.touched) ) {
                    <div class="error-message">
                      {{ validation.message }}
                    </div>
                  }
                }
              </div>
            </div>
          </div>
        }
      </div>
    </div>

  <div class="col-12 text-center mt-4" style="justify-content: center;">
    <button class="btn btn-custom btn-warning px-xxl-5 m-3" (click)="backToHome()">
      <b>Back</b>
    </button>
    <button class="btn btn-custom btn-warning px-xxl-5 m-3" (click)="reuploadFiles()" >
      <b title="Upload a new design file to start the flow from scratch">Re-upload File</b>
    </button>
    <button class="btn btn-custom btn-warning btn_blue_custom px-xxl-5 m-3" (click)="goToQuotePage(quotesListModal)" >
      <b>Proceed</b>
    </button>
    <button id="specificationList" hidden (click)="openListOfSpecification(listOfSpecification)"></button>
    <button id="itarFlowModalInfo" hidden (click)="openItarFlowFn(itarCheckYes)"></button>
  </div>
</div>
</form>

</div>
<!-- <div>
<form id="mktoForm_2584" style="visibility:hidden;"></form>
</div> -->

<!-- Quotes List MODAL -->
<ng-template #quotesListModal let-modal class="address-book-modal">
  <div class="modal-header">
    <div class="row col">
      <div class="col-11 text-center">
        <h4 class="modal-title p-1" id="modal-basic-title">Quotes List Details</h4>
      </div>
      <div class="col-1 text-right">
        <button type="button" class="close btn btn-warning modal-close p-0" aria-label="Close" (click)="modal.dismiss('Cross click')">
          <span aria-hidden="true" class="modal-crose">×</span>
        </button>
      </div>
    </div>
  </div>
  <div class="modal-body pt-0">
    <div class="mb-3 mt-1point5">
      An active quote already exists for this part number and revision. You can view the existing quote by clicking on the SPX link and place an order. Else, you can generate a new quote by clicking on ‘Generate New Quote’ button.
    </div>
    <div class="col-12">
      <div class="col-12 mb-3 justify-content-center" id="quoteListDetails">
        <div class="col-sm-12">
          <div class="table-responsive" id="quoteListDetailsTable">
            <table width="100%" border="0" cellspacing="0" cellpadding="0" id="Quote-items-to-purchase" class="table table-bordered">
              <thead>
                <tr>
                  <th style="width: 8%;" align="center" valign="middle">Quote ID</th>
                  <th style="width: 12%;" align="center" valign="middle">PCB Quantity</th>
                  <th style="width: 12%;" align="center" valign="middle">PCB Turn Time</th>
                  <th style="width: 14%;" align="center" valign="middle">Assembly Quantity</th>
                  <th style="width: 18%;" align="center" valign="middle"> Assembly Turntime </th>
                  <th style="width: 18%;" align="center" valign="middle"> SPX </th>
                </tr>
              </thead>
              <tbody id="display-tbody-issues">
                @for (quoteObj of commonService.commonMainObj.listOfQuotesData; track quoteObj) {
                  <tr>
                    <td align="center" valign="top" style="width: 150px;">{{quoteObj.quoteId}}</td>
                    <td align="center" valign="top" style="width: 100px;">{{quoteObj.pcbQuantity}}</td>
                    <td align="center" valign="top" style="width: 150px;">{{quoteObj.pcbTurnTime}}</td>
                    <td align="center" valign="top" style="width: 150;">{{quoteObj.assemblyQuantity}}</td>
                    <td align="center" valign="top" style="width: 150;"> {{quoteObj.assemblyTurnTime}} </td>
                    <td align="center" valign="top" style="width: 150;"><a href="{{quoteObj.spxUrl}}" target="_blank">{{quoteObj.spxNumber}}</a></td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer text-center" style="display: block;">
    <div class="fw-bold text-danger mb-2" id="errorMsg"> </div>
    <button type="button" class="btn btn-custom btn-warning px-xxl-5 btn-danger btn-red-custom" (click)="modal.dismiss('close click')"><b>Cancel</b></button>
    <button type="button" class="btn btn-custom btn-warning px-xxl-5" (click)="modal.dismiss('OK')"><b>Generate New Quote</b></button>
  </div>
</ng-template>
<!--OFP-2354-->
<ng-template #listOfSpecification let-modal class="address-book-modal">
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">Due to the following advanced specification, this quote request will be treated as custom quote and is ineligible for an instant online quote. We need to further assess the files and specification offline to generate a quote.<br />Please review and confirm if you would like to proceed with custom quote.</h4>
  </div>
  <div class="modal-body">
    <div class="row m-0 mt-2 mb-3" style="margin-left: 1rem !important;">
      <ul>
        @for (item of commonService.commonMainObj.customQuoteParam | keyvalue; track item.key) {
          <li style="list-style-type: auto;padding-bottom: 2px">{{item.value}}</li>
        }
      </ul>
    </div>
  </div>
  <div class="modal-footer text-center" style="display: block;">
    <button type="button" class="btn btn-custom btn-warning px-xxl-5 m-3 btn-danger btn-red-custom" (click)="modal.close('cancel click')"><b>Cancel</b></button>
    <button type="button" class="btn btn-custom btn-warning btn_blue_custom px-xxl-5 m-3" (click)="goToQuotePageChecked()" ><b>Confirm</b></button>
  </div>
</ng-template>

<!--OFP-3028-->
<ng-template #itarCheckYes let-modal class="itar-flow-modal">
  <div class="modal-header">
    <div class="row col text-right">
      <button type="button" class="close btn btn-warning modal-close p-0" aria-label="Close" (click)="modal.dismiss('Cross click')">
        <span aria-hidden="true" class="modal-crose">×</span>
      </button>
    </div>
  </div>
  <div class="modal-body text-center">
    <div class="row m-0">
      <div>
        <h4 class="fs-5">This file may contain ITAR or export-controlled information.</h4>
        <h4 class="fs-5">To ensure it is handled through the appropriate process, please upload these files using the ITAR workflow.</h4>
      </div>
      <div class="mt-1">
        <a class="fs-5" id="go-to-itar-workflow-link" target="_blank" href="{{apiService.customQuoteUrl}}" (click)="goToItarFlow();modal.dismiss('Cross click')">Go to ITAR Workflow</a>
      </div>
    </div>
  </div>
  <div class="modal-footer text-center" style="display: block;">
    <button type="button" class="btn btn-custom btn-warning btn_blue_custom" (click)="continueWithItar(quotesListModal)" ><b>Proceed With The Current Flow</b></button>
  </div>
</ng-template>
</section>
<app-footer></app-footer>